/* Barrierefreiheits-Korrekturen fuer danichou.de
 *
 * 1. Buttons ohne type-Attribut: Ohne type gilt "submit" als Standard. Steht so ein
 *    Button in einem Formular, loest ein Klick oder die Eingabetaste ein ungewolltes
 *    Absenden aus (WCAG 3.2.2). Ergaenzt wird type="button" nur dort, wo es
 *    nachweislich sicher ist: bei Buttons ausserhalb jedes Formulars und bei der
 *    Sprach- und Laenderauswahl. Die Such-Buttons bleiben unberuehrt, die brauchen
 *    ihr Submit-Verhalten.
 *
 * 2. Footer-Landmark: Das Theme rendert den Footer als div ohne Landmark-Rolle,
 *    dadurch liegen Inhalte ausserhalb jeder Landmark (WCAG 2.4.1).
 *
 * Das ist eine Uebergangsloesung. Sauberer waere beides direkt in den Theme-Dateien,
 * die sind mit 488 KB und 91 KB aber nicht sicher automatisiert bearbeitbar.
 */
(function () {
  var scheduled = false;

  function fixButtons() {
    scheduled = false;
    var list = document.querySelectorAll('button:not([type])');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      var f = b.closest ? b.closest('form') : null;
      if (!f || (f.getAttribute('action') || '').indexOf('/localization') === 0) {
        b.setAttribute('type', 'button');
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(fixButtons);
    } else {
      setTimeout(fixButtons, 0);
    }
  }

  function fixLandmarks() {
    var f = document.getElementById('section-footer');
    if (f && !f.getAttribute('role')) {
      f.setAttribute('role', 'contentinfo');
    }
  }

  function start() {
    fixButtons();
    fixLandmarks();
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
